// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `nav {
  background-color: transparent;
  padding: 1em 0 2em 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
  top: 0;
  position: relative;
}

.menu {
  width: 95%;
}

nav ul {
  display: flex;
  align-items: center;
}

nav ul li {
  list-style: none;
  font-weight: bold;
  text-decoration: none;
  font-size: 46px;
}

nav ul li a,
nav ul li span {
  display: block;
  text-decoration: none;
  padding: 0 0.5rem;
  margin: 0 0.5rem;
  border-radius: 0.5rem;
}

nav .title,
.hamburger-menu-icon,
.empty-span {
  font-size: 1.5em;
  font-weight: bold;
  text-decoration: none;
}

.empty-span {
  width: 0.67em;
}

.title-hidden {
  visibility: hidden;
}

nav a:not(.title):hover,
.dropdown > span:hover {
  font-style: italic;
}

.x {
  display: inline-grid;
  width: max-content;
  margin: 0;
  padding: 0;
}

.y {
  grid-area: 1 / 1 / 2 / 2;
  display: inline-flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin: 0;
  padding: 0;
}

.z {
  visibility: hidden;
  font-style: italic;
}

.p {
  visibility: hidden;

  font-style: normal;
}

.features-menu {
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: start;
  position: absolute;
  top: 2.8rem;
  left: 0;
  z-index: 1;
}

.features-menu li {
  list-style: none;
  padding: 0 0.5rem;
  margin: 0 0.5rem;
}

.features-menu li a {
  list-style: none;
  margin: 0;
  padding: 0;
}

.features-menu li:last-of-type {
  border-bottom: none;
}

.dropdown {
  position: relative;
}

.dropdown > span {
  z-index: 0;
  position: relative;
  cursor: pointer;
}

.hamburger-menu-icon {
  display: none;
}

@media screen and (max-width: 1350px) {
  .menu > li,
  .menu > li > ul > li {
    font-size: 95%;
  }
  main > #lower-left-title {
    font-size: 2.5em;
    bottom: 0.75em;
    left: 0.75em;
  }
}

.hamburger span {
  height: 0.5rem;
  width: 100%;
  background-color: var(--fg);
}

/* Hamburger starts here */
@media screen and (max-width: 1230px) {
  .hamburger-menu-icon {
    display: inline;
  }

  .footer.menu-open {
    display: none;
  }

  .media-hidden {
    display: none;
  }

  nav.menu-open {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    height: 100dvh;
    width: 100dvw;
    color: var(--bg);
    background-color: var(--fg);
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
  }

  .name-hamburger-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;
    width: 100dvw;
    padding: 0 1rem;
  }

  .menu-closed > .menu {
    display: none;
  }

  #nav-name {
    text-align: center;
  }

  nav.menu-open ul li {
    margin: 1em;
  }

  .title-hidden {
    visibility: visible;
  }

  nav .hamburger {
    display: flex;
  }

  nav ul {
    flex-direction: column;
  }

  nav ul.open {
    display: flex;
  }

  nav ul li {
    width: 100%;
    text-align: center;
  }

  nav ul li a {
    margin: 0.2rem 0.5rem;
  }

  .features-menu {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: auto;
    position: inherit;
  }

  .features-menu li {
  }
}

@media screen and (max-width: 560px) {
  a.title {
    width: 30%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Navbar/index.css"],"names":[],"mappings":"AAAA;EACE,6BAA6B;EAC7B,oBAAoB;EACpB,aAAa;EACb,6BAA6B;EAC7B,mBAAmB;EACnB,MAAM;EACN,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,eAAe;AACjB;;AAEA;;EAEE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;;;EAGE,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;AACpB;;AAEA;;EAEE,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,wBAAwB;EACxB,oBAAoB;EACpB,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;;EAElB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;EACX,OAAO;EACP,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE;;IAEE,cAAc;EAChB;EACA;IACE,gBAAgB;IAChB,cAAc;IACd,YAAY;EACd;AACF;;AAEA;EACE,cAAc;EACd,WAAW;EACX,2BAA2B;AAC7B;;AAEA,0BAA0B;AAC1B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,gBAAgB;IAChB,2BAA2B;IAC3B,eAAe;IACf,MAAM;IACN,OAAO;IACP,aAAa;EACf;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;IACrB,aAAa;IACb,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,iBAAiB;EACnB;;EAEA;EACA;AACF;;AAEA;EACE;IACE,UAAU;EACZ;AACF","sourcesContent":["nav {\n  background-color: transparent;\n  padding: 1em 0 2em 0;\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  top: 0;\n  position: relative;\n}\n\n.menu {\n  width: 95%;\n}\n\nnav ul {\n  display: flex;\n  align-items: center;\n}\n\nnav ul li {\n  list-style: none;\n  font-weight: bold;\n  text-decoration: none;\n  font-size: 46px;\n}\n\nnav ul li a,\nnav ul li span {\n  display: block;\n  text-decoration: none;\n  padding: 0 0.5rem;\n  margin: 0 0.5rem;\n  border-radius: 0.5rem;\n}\n\nnav .title,\n.hamburger-menu-icon,\n.empty-span {\n  font-size: 1.5em;\n  font-weight: bold;\n  text-decoration: none;\n}\n\n.empty-span {\n  width: 0.67em;\n}\n\n.title-hidden {\n  visibility: hidden;\n}\n\nnav a:not(.title):hover,\n.dropdown > span:hover {\n  font-style: italic;\n}\n\n.x {\n  display: inline-grid;\n  width: max-content;\n  margin: 0;\n  padding: 0;\n}\n\n.y {\n  grid-area: 1 / 1 / 2 / 2;\n  display: inline-flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  margin: 0;\n  padding: 0;\n}\n\n.z {\n  visibility: hidden;\n  font-style: italic;\n}\n\n.p {\n  visibility: hidden;\n\n  font-style: normal;\n}\n\n.features-menu {\n  display: flex;\n  flex-direction: column;\n  justify-content: start;\n  align-items: start;\n  position: absolute;\n  top: 2.8rem;\n  left: 0;\n  z-index: 1;\n}\n\n.features-menu li {\n  list-style: none;\n  padding: 0 0.5rem;\n  margin: 0 0.5rem;\n}\n\n.features-menu li a {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n}\n\n.features-menu li:last-of-type {\n  border-bottom: none;\n}\n\n.dropdown {\n  position: relative;\n}\n\n.dropdown > span {\n  z-index: 0;\n  position: relative;\n  cursor: pointer;\n}\n\n.hamburger-menu-icon {\n  display: none;\n}\n\n@media screen and (max-width: 1350px) {\n  .menu > li,\n  .menu > li > ul > li {\n    font-size: 95%;\n  }\n  main > #lower-left-title {\n    font-size: 2.5em;\n    bottom: 0.75em;\n    left: 0.75em;\n  }\n}\n\n.hamburger span {\n  height: 0.5rem;\n  width: 100%;\n  background-color: var(--fg);\n}\n\n/* Hamburger starts here */\n@media screen and (max-width: 1230px) {\n  .hamburger-menu-icon {\n    display: inline;\n  }\n\n  .footer.menu-open {\n    display: none;\n  }\n\n  .media-hidden {\n    display: none;\n  }\n\n  nav.menu-open {\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    height: 100dvh;\n    width: 100dvw;\n    color: var(--bg);\n    background-color: var(--fg);\n    position: fixed;\n    top: 0;\n    left: 0;\n    z-index: 1000;\n  }\n\n  .name-hamburger-container {\n    display: flex;\n    flex-direction: row;\n    justify-content: space-between;\n    align-items: baseline;\n    width: 100dvw;\n    padding: 0 1rem;\n  }\n\n  .menu-closed > .menu {\n    display: none;\n  }\n\n  #nav-name {\n    text-align: center;\n  }\n\n  nav.menu-open ul li {\n    margin: 1em;\n  }\n\n  .title-hidden {\n    visibility: visible;\n  }\n\n  nav .hamburger {\n    display: flex;\n  }\n\n  nav ul {\n    flex-direction: column;\n  }\n\n  nav ul.open {\n    display: flex;\n  }\n\n  nav ul li {\n    width: 100%;\n    text-align: center;\n  }\n\n  nav ul li a {\n    margin: 0.2rem 0.5rem;\n  }\n\n  .features-menu {\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    z-index: auto;\n    position: inherit;\n  }\n\n  .features-menu li {\n  }\n}\n\n@media screen and (max-width: 560px) {\n  a.title {\n    width: 30%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
